/* eslint-disable */ /**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */

import * as Types from '../../../../app/services/types.generated';

import { api } from 'app/graphqlBaseApi';
module.hot?.accept();
export type UploadOnboardingFileMutationVariables = Types.Exact<{
  input: Types.OnboardingUploadFileInput;
}>;


export type UploadOnboardingFileMutation = { __typename?: 'Mutation', uploadOnboardingFile: { __typename?: 'OnboardingUploadFileResponse', success: boolean, statusCode: number, customerData?: { __typename?: 'CustomerItems', items?: Array<{ __typename?: 'Customer', name?: string, fcaAuthorisation?: string, id?: string, platformId?: string, type?: string, whiteLabelType?: string, externalCustomerCode?: string, address?: { __typename?: 'Address', line1?: string, line2?: string, line3?: string, line4?: string, line5?: string, postcode?: string }, bank?: { __typename?: 'Bank', accountNumber?: string, sortCode?: string }, branding?: { __typename?: 'Branding', id?: string, name?: string, relationship?: string }, buyList?: { __typename?: 'BuyList', id?: string }, contact?: { __typename?: 'Contact', email?: string, senderEmail?: string } }> }, modelData?: { __typename?: 'ModelItems', items?: Array<{ __typename?: 'Model', customerId?: string, platformId?: string, name?: string, relationship?: string, key?: { __typename?: 'Key', customerId?: string, id?: string, date?: string }, charges?: { __typename?: 'ModelCharges', dfmAnnualCharge?: { __typename?: 'DfmAnnualCharge', id?: string } } }> }, productData?: { __typename?: 'ProductItems', items?: Array<{ __typename?: 'Product', id?: string, customerId?: string, bankCode?: string, group?: string, prefix?: string, name?: string, charges?: { __typename?: 'ProductCharges', platformAnnualCharge?: { __typename?: 'PlatformAnnualCharge', id?: string }, productAnnualCharge?: { __typename?: 'ProductAnnualCharge', id?: string } }, limits?: { __typename?: 'Limits', maxAccountHolders?: number, maxAccounts?: number, maxInvestments?: { __typename?: 'MaxInvestments', initial?: number, initialAmendments?: number, regular?: number, regularAmendments?: number }, maxTransfers?: { __typename?: 'MaxTransfers', amendments?: number, total?: number }, minValues?: { __typename?: 'MinValues', initial?: number, regular?: number, topUp?: number, transfer?: number } }, phasePeriods?: { __typename?: 'PhasePeriods', monthly?: { __typename?: 'Monthly', min?: number, max?: number, value?: number } } }> } } };


export const UploadOnboardingFileDocument = `
    mutation UploadOnboardingFile($input: OnboardingUploadFileInput!) {
  uploadOnboardingFile(input: $input) {
    success
    statusCode
    customerData {
      items {
        name
        address {
          line1
          line2
          line3
          line4
          line5
          postcode
        }
        bank {
          accountNumber
          sortCode
        }
        branding {
          id
          name
          relationship
        }
        buyList {
          id
        }
        contact {
          email
          senderEmail
        }
        fcaAuthorisation
        id
        platformId
        type
        whiteLabelType
        externalCustomerCode
      }
    }
    modelData {
      items {
        customerId
        platformId
        name
        key {
          customerId
          id
          date
        }
        relationship
        charges {
          dfmAnnualCharge {
            id
          }
        }
      }
    }
    productData {
      items {
        id
        customerId
        bankCode
        group
        prefix
        name
        charges {
          platformAnnualCharge {
            id
          }
          productAnnualCharge {
            id
          }
        }
        limits {
          maxAccountHolders
          maxAccounts
          maxInvestments {
            initial
            initialAmendments
            regular
            regularAmendments
          }
          maxTransfers {
            amendments
            total
          }
          minValues {
            initial
            regular
            topUp
            transfer
          }
        }
        phasePeriods {
          monthly {
            min
            max
            value
          }
        }
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    UploadOnboardingFile: build.mutation<UploadOnboardingFileMutation, UploadOnboardingFileMutationVariables>({
      query: (variables) => ({ document: UploadOnboardingFileDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUploadOnboardingFileMutation } = injectedRtkApi;

